/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createFreeSubscription = /* GraphQL */ `
  mutation CreateFreeSubscription(
    $email: String
    $name: String
    $units: Int
    $priceId: String
  ) {
    createFreeSubscription(
      email: $email
      name: $name
      units: $units
      priceId: $priceId
    ) {
      status
      response
    }
  }
`;
export const createStripeSubscription = /* GraphQL */ `
  mutation CreateStripeSubscription(
    $email: String
    $paymentMethodId: String
    $priceId: String
    $units: Int
    $promoCodeId: String
    $trialPeriod: Int
    $name: String
    $createdBy: Int
  ) {
    createStripeSubscription(
      email: $email
      paymentMethodId: $paymentMethodId
      priceId: $priceId
      units: $units
      promoCodeId: $promoCodeId
      trialPeriod: $trialPeriod
      name: $name
      createdBy: $createdBy
    ) {
      status
      response
    }
  }
`;
export const createStripeFreeTrial = /* GraphQL */ `
  mutation CreateStripeFreeTrial(
    $email: String
    $name: String
    $priceId: String
    $units: Int
    $trialPeriod: Int
  ) {
    createStripeFreeTrial(
      email: $email
      name: $name
      priceId: $priceId
      units: $units
      trialPeriod: $trialPeriod
    ) {
      status
      response
    }
  }
`;
export const createPlaidLink = /* GraphQL */ `
  mutation CreatePlaidLink(
    $userId: String
    $userName: String
    $accessToken: String
    $syncAccount: String
  ) {
    createPlaidLink(
      userId: $userId
      userName: $userName
      accessToken: $accessToken
      syncAccount: $syncAccount
    ) {
      status
      response
    }
  }
`;
export const createTenantPlaidLink = /* GraphQL */ `
  mutation CreateTenantPlaidLink(
    $userId: String
    $userName: String
    $accessToken: String
    $syncAccount: String
  ) {
    createTenantPlaidLink(
      userId: $userId
      userName: $userName
      accessToken: $accessToken
      syncAccount: $syncAccount
    ) {
      status
      response
    }
  }
`;
export const updateStripeSubscription = /* GraphQL */ `
  mutation UpdateStripeSubscription(
    $subscriptionId: String
    $priceId: String
    $units: Int
    $promoCodeId: String
    $itemId: String
    $createdBy: Int
  ) {
    updateStripeSubscription(
      subscriptionId: $subscriptionId
      priceId: $priceId
      units: $units
      promoCodeId: $promoCodeId
      itemId: $itemId
      createdBy: $createdBy
    ) {
      status
      response
    }
  }
`;
export const updateStripeUnits = /* GraphQL */ `
  mutation UpdateStripeUnits(
    $subscriptionId: String
    $units: Int
    $createdBy: Int
  ) {
    updateStripeUnits(
      subscriptionId: $subscriptionId
      units: $units
      createdBy: $createdBy
    ) {
      status
      response
    }
  }
`;
export const createStripeQuote = /* GraphQL */ `
  mutation CreateStripeQuote($priceId: String, $units: Int) {
    createStripeQuote(priceId: $priceId, units: $units) {
      status
      response
    }
  }
`;
export const addUserToGroup = /* GraphQL */ `
  mutation AddUserToGroup($userName: String, $userPoolId: String) {
    addUserToGroup(userName: $userName, userPoolId: $userPoolId) {
      status
      response
    }
  }
`;
export const uploadDocument = /* GraphQL */ `
  mutation UploadDocument(
    $fileName: String
    $base64Data: String
    $contentType: String
  ) {
    uploadDocument(
      fileName: $fileName
      base64Data: $base64Data
      contentType: $contentType
    ) {
      status
      response
    }
  }
`;
export const updateStripePaymentMethod = /* GraphQL */ `
  mutation UpdateStripePaymentMethod(
    $subscriptionId: String
    $paymentMethodId: String
    $customerId: String
  ) {
    updateStripePaymentMethod(
      subscriptionId: $subscriptionId
      paymentMethodId: $paymentMethodId
      customerId: $customerId
    ) {
      status
      response
    }
  }
`;
export const addStripePaymentMethod = /* GraphQL */ `
  mutation AddStripePaymentMethod(
    $customerId: String
    $paymentMethodId: String
  ) {
    addStripePaymentMethod(
      customerId: $customerId
      paymentMethodId: $paymentMethodId
    ) {
      status
      response
    }
  }
`;
export const transferUserDocument = /* GraphQL */ `
  mutation TransferUserDocument(
    $userDocumentID: Int
    $selectedPropertyId: String
    $suggestedPropertyId: String
    $selectedDocumentTypeId: Int
    $suggestedDocumentTypeId: Int
  ) {
    transferUserDocument(
      userDocumentID: $userDocumentID
      selectedPropertyId: $selectedPropertyId
      suggestedPropertyId: $suggestedPropertyId
      selectedDocumentTypeId: $selectedDocumentTypeId
      suggestedDocumentTypeId: $suggestedDocumentTypeId
    ) {
      status
      response
    }
  }
`;

export const createNotification = /* GraphQL */ `
  mutation CreateNotification(
    $userId: Int
    $documentId: Int
    $notificationType: String
    $title: String
    $message: String
    $status: String
  ) {
    createNotification(
      userId: $userId
      documentId: $documentId
      notificationType: $notificationType
      title: $title
      message: $message
      status: $status
    ) {
      status
      response
    }
  }
`;

export const createDwollaCustomer = /* GraphQL */ `
  mutation CreateDwollaCustomer(
    $firstName: String
    $lastName: String
    $email: String
    $address1: String
    $city: String
    $state: String
    $dateOfBirth: AWSDate
    $postalCode: String
    $ssn: String
    $type: String
    $businessClassification: String
    $businessName: String
    $businessType: String
    $ein: String
    $controllerAddress1: String
    $controllerCity: String
    $controllerCountry: String
    $controllerPostalCode: String
    $controllerState: String
    $controllerFirstName: String
    $controllerLastName: String
    $controllerTitle: String
    $ownerFirstName: String
    $ownerLastName: String
    $ownerAddress1: String
    $ownerCity: String
    $ownerState: String
    $ownerPostalCode: String
    $ownerDateOfBirth: String
    $ownerSsn: String
    $ownerCountry: String
  ) {
    createDwollaCustomer(
      firstName: $firstName
      lastName: $lastName
      email: $email
      address1: $address1
      city: $city
      state: $state
      dateOfBirth: $dateOfBirth
      postalCode: $postalCode
      ssn: $ssn
      type: $type
      businessClassification: $businessClassification
      businessName: $businessName
      businessType: $businessType
      ein: $ein
      controllerAddress1: $controllerAddress1
      controllerCity: $controllerCity
      controllerCountry: $controllerCountry
      controllerPostalCode: $controllerPostalCode
      controllerState: $controllerState
      controllerFirstName: $controllerFirstName
      controllerLastName: $controllerLastName
      controllerTitle: $controllerTitle
      ownerFirstName: $ownerFirstName
      ownerLastName: $ownerLastName
      ownerAddress1: $ownerAddress1
      ownerCity: $ownerCity
      ownerState: $ownerState
      ownerPostalCode: $ownerPostalCode
      ownerDateOfBirth: $ownerDateOfBirth
      ownerSsn: $ownerSsn
      ownerCountry: $ownerCountry
    ) {
      status
      response
    }
  }
`;
export const createDwollaCustomerV2 = /* GraphQL */ `
  mutation CreateDwollaCustomerV2(
    $firstName: String
    $lastName: String
    $email: String
    $address1: String
    $city: String
    $state: String
    $dateOfBirth: AWSDate
    $postalCode: String
    $ssn: String
    $type: String
    $businessClassification: String
    $businessName: String
    $businessType: String
    $ein: String
    $controllerAddress1: String
    $controllerCity: String
    $controllerCountry: String
    $controllerPostalCode: String
    $controllerState: String
    $controllerFirstName: String
    $controllerLastName: String
    $controllerTitle: String
    $ownerFirstName: String
    $ownerLastName: String
    $ownerAddress1: String
    $ownerCity: String
    $ownerState: String
    $ownerPostalCode: String
    $ownerDateOfBirth: String
    $ownerSsn: String
    $ownerCountry: String
    $base64: String
    $filetype: String
    $documentType: String
    $documentName: String
    $createdBy: Int
  ) {
    createDwollaCustomerV2(
      firstName: $firstName
      lastName: $lastName
      email: $email
      address1: $address1
      city: $city
      state: $state
      dateOfBirth: $dateOfBirth
      postalCode: $postalCode
      ssn: $ssn
      type: $type
      businessClassification: $businessClassification
      businessName: $businessName
      businessType: $businessType
      ein: $ein
      controllerAddress1: $controllerAddress1
      controllerCity: $controllerCity
      controllerCountry: $controllerCountry
      controllerPostalCode: $controllerPostalCode
      controllerState: $controllerState
      controllerFirstName: $controllerFirstName
      controllerLastName: $controllerLastName
      controllerTitle: $controllerTitle
      ownerFirstName: $ownerFirstName
      ownerLastName: $ownerLastName
      ownerAddress1: $ownerAddress1
      ownerCity: $ownerCity
      ownerState: $ownerState
      ownerPostalCode: $ownerPostalCode
      ownerDateOfBirth: $ownerDateOfBirth
      ownerSsn: $ownerSsn
      ownerCountry: $ownerCountry
      base64: $base64
      filetype: $filetype
      documentType: $documentType
      documentName: $documentName
      createdBy: $createdBy
    ) {
      status
      response
    }
  }
`;
export const createDwollaUnverifiedCustomer = /* GraphQL */ `
  mutation CreateDwollaUnverifiedCustomer(
    $firstName: String
    $lastName: String
    $email: String
    $ipAddress: String
  ) {
    createDwollaUnverifiedCustomer(
      firstName: $firstName
      lastName: $lastName
      email: $email
      ipAddress: $ipAddress
    ) {
      status
      response
    }
  }
`;
export const retryDwollaCustomer = /* GraphQL */ `
  mutation RetryDwollaCustomer(
    $firstName: String
    $lastName: String
    $email: String
    $address1: String
    $city: String
    $state: String
    $dateOfBirth: AWSDate
    $postalCode: String
    $ssn: String
    $type: String
    $businessClassification: String
    $businessName: String
    $businessType: String
    $ein: String
    $controllerAddress1: String
    $controllerCity: String
    $controllerCountry: String
    $controllerPostalCode: String
    $controllerState: String
    $controllerFirstName: String
    $controllerLastName: String
    $controllerTitle: String
    $ownerFirstName: String
    $ownerLastName: String
    $ownerAddress1: String
    $ownerCity: String
    $ownerState: String
    $ownerPostalCode: String
    $ownerDateOfBirth: String
    $ownerSsn: String
    $ownerCountry: String
    $customerId: String
  ) {
    retryDwollaCustomer(
      firstName: $firstName
      lastName: $lastName
      email: $email
      address1: $address1
      city: $city
      state: $state
      dateOfBirth: $dateOfBirth
      postalCode: $postalCode
      ssn: $ssn
      type: $type
      businessClassification: $businessClassification
      businessName: $businessName
      businessType: $businessType
      ein: $ein
      controllerAddress1: $controllerAddress1
      controllerCity: $controllerCity
      controllerCountry: $controllerCountry
      controllerPostalCode: $controllerPostalCode
      controllerState: $controllerState
      controllerFirstName: $controllerFirstName
      controllerLastName: $controllerLastName
      controllerTitle: $controllerTitle
      ownerFirstName: $ownerFirstName
      ownerLastName: $ownerLastName
      ownerAddress1: $ownerAddress1
      ownerCity: $ownerCity
      ownerState: $ownerState
      ownerPostalCode: $ownerPostalCode
      ownerDateOfBirth: $ownerDateOfBirth
      ownerSsn: $ownerSsn
      ownerCountry: $ownerCountry
      customerId: $customerId
    ) {
      status
      response
    }
  }
`;
export const updateDwollaCustomer = /* GraphQL */ `
  mutation UpdateDwollaCustomer($customerId: String, $status: String) {
    updateDwollaCustomer(customerId: $customerId, status: $status) {
      status
      response
    }
  }
`;
export const createStripePaymentMethod = /* GraphQL */ `
  mutation CreateStripePaymentMethod(
    $number: String
    $exp_month: Int
    $exp_year: Int
    $cvc: String
    $name: String
    $address: String
    $city: String
    $state: String
    $zip: String
  ) {
    createStripePaymentMethod(
      number: $number
      exp_month: $exp_month
      exp_year: $exp_year
      cvc: $cvc
      name: $name
      address: $address
      city: $city
      state: $state
      zip: $zip
    ) {
      status
      response
    }
  }
`;
export const copyDocument = /* GraphQL */ `
  mutation CopyDocument($fileName: String) {
    copyDocument(fileName: $fileName) {
      status
      response
    }
  }
`;
export const cancelStripeSubscription = /* GraphQL */ `
  mutation CancelStripeSubscription($subscriptionId: String) {
    cancelStripeSubscription(subscriptionId: $subscriptionId) {
      status
      response
    }
  }
`;
export const deleteDwollaFundingSource = /* GraphQL */ `
  mutation DeleteDwollaFundingSource($sourceId: String) {
    deleteDwollaFundingSource(sourceId: $sourceId) {
      status
      response
    }
  }
`;
export const uploadDwollaDocument = /* GraphQL */ `
  mutation UploadDwollaDocument($data: String!) {
    uploadDwollaDocument(data: $data) {
      status
      response
    }
  }
`;
export const createStripeWebhook = /* GraphQL */ `
  mutation CreateStripeWebhook(
    $url: String
    $event: String
    $description: String
  ) {
    createStripeWebhook(url: $url, event: $event, description: $description) {
      status
      response
    }
  }
`;
export const deleteTenantAccount = /* GraphQL */ `
  mutation DeleteTenantAccount(
    $id: Int
    $created_by: Int
    $user_pool_id: String
    $property_lease_id: Int
  ) {
    deleteTenantAccount(
      id: $id
      created_by: $created_by
      user_pool_id: $user_pool_id
      property_lease_id: $property_lease_id
    ) {
      status
      response
    }
  }
`;
export const updateRdsData = /* GraphQL */ `
  mutation UpdateRdsData($name: String, $data: String) {
    updateRdsData(name: $name, data: $data) {
      status
      response
    }
  }
`;
export const insertPropertyUnits = /* GraphQL */ `
  mutation InsertPropertyUnits(
    $time: String
    $unitNames: [String]
    $userId: Int
    $propertyId: Int
  ) {
    insertPropertyUnits(
      time: $time
      unitNames: $unitNames
      userId: $userId
      propertyId: $propertyId
    ) {
      status
      response
    }
  }
`;
export const insertPropertyUnitsV2 = /* GraphQL */ `
  mutation InsertPropertyUnitsV2(
    $time: String
    $unitData: String
    $userId: Int
    $propertyId: Int
  ) {
    insertPropertyUnitsV2(
      time: $time
      unitData: $unitData
      userId: $userId
      propertyId: $propertyId
    ) {
      status
      response
    }
  }
`;
export const getEstatedPropertyData = /* GraphQL */ `
  mutation GetEstatedPropertyData($address: String) {
    getEstatedPropertyData(address: $address) {
      status
      response
    }
  }
`;
export const updatePropertyUnitsV2 = /* GraphQL */ `
  mutation UpdatePropertyUnitsV2(
    $time: String
    $unitData: String
    $userId: Int
    $propertyId: Int
    $units: Int
  ) {
    updatePropertyUnitsV2(
      time: $time
      unitData: $unitData
      userId: $userId
      propertyId: $propertyId
      units: $units
    ) {
      status
      response
    }
  }
`;
export const importCsv = /* GraphQL */ `
  mutation ImportCsv(
    $userId: Int
    $portfolioId: Int
    $fileName: String
    $recordType: String
    $time: String
  ) {
    importCsv(
      userId: $userId
      portfolioId: $portfolioId
      fileName: $fileName
      recordType: $recordType
      time: $time
    ) {
      status
      response
    }
  }
`;
export const uploadUserDocument = /* GraphQL */ `
  mutation UploadUserDocument(
    $base64: String
    $originalFileName: String
    $fileName: String
    $userId: Int
  ) {
    uploadUserDocument(
      base64: $base64
      originalFileName: $originalFileName
      fileName: $fileName
      userId: $userId
    ) {
      status
      response
    }
  }
`;
export const deleteRdsData = /* GraphQL */ `
  mutation DeleteRdsData($name: String, $data: String) {
    deleteRdsData(name: $name, data: $data) {
      status
      response
    }
  }
`;
export const signOut = /* GraphQL */ `
  mutation SignOut($clientId: String, $token: String) {
    signOut(clientId: $clientId, token: $token) {
      status
      response
    }
  }
`;
export const revokeAppleTokens = /* GraphQL */ `
  mutation RevokeAppleTokens($token: String, $accessToken: String) {
    revokeAppleTokens(token: $token, accessToken: $accessToken) {
      status
      response
    }
  }
`;
export const importTransactions = /* GraphQL */ `
  mutation ImportTransactions(
    $timestamp: String
    $transactions: String
    $userId: Int
  ) {
    importTransactions(
      timestamp: $timestamp
      transactions: $transactions
      userId: $userId
    ) {
      status
      response
    }
  }
`;
export const deleteUserAccountV2 = /* GraphQL */ `
  mutation DeleteUserAccountV2(
    $userPoolId: String
    $username: String
    $userId: Int
    $subscriptionId: String
  ) {
    deleteUserAccountV2(
      userPoolId: $userPoolId
      username: $username
      userId: $userId
      subscriptionId: $subscriptionId
    ) {
      status
      response
    }
  }
`;
export const insertPropertyProforma = /* GraphQL */ `
  mutation InsertPropertyProforma($data: String) {
    insertPropertyProforma(data: $data) {
      status
      response
    }
  }
`;
export const mutatePropertyProforma = /* GraphQL */ `
  mutation MutatePropertyProforma($data: String) {
    mutatePropertyProforma(data: $data) {
      status
      response
    }
  }
`;
export const updateLambdaResolver = /* GraphQL */ `
  mutation UpdateLambdaResolver($table: String!, $data: String!) {
    updateLambdaResolver(table: $table, data: $data) {
      status
      response
    }
  }
`;
export const createLambdaResolver = /* GraphQL */ `
  mutation CreateLambdaResolver($table: String!, $data: String!) {
    createLambdaResolver(table: $table, data: $data) {
      status
      response
    }
  }
`;
export const highConfidenceDocumentFlow = /* GraphQL */ `
  mutation HighConfidenceDocumentFlow(
    $documentId: Int!
    $propertyId: Int!
    $documentTypeId: Int!
  ) {
    highConfidenceDocumentFlow(
      documentId: $documentId
      propertyId: $propertyId
      documentTypeId: $documentTypeId
    ) {
      status
      response
    }
  }
`;
export const addPortfolio = /* GraphQL */ `
  mutation AddPortfolio($data: String!) {
    addPortfolio(data: $data) {
      status
      response
    }
  }
`;
export const addTransaction = /* GraphQL */ `
  mutation AddTransaction($data: String!) {
    addTransaction(data: $data) {
      status
      response
    }
  }
`;
export const addTenantPayment = /* GraphQL */ `
  mutation AddTenantPayment($data: String!) {
    addTenantPayment(data: $data) {
      status
      response
    }
  }
`;
export const editPortfolio = /* GraphQL */ `
  mutation EditPortfolio($data: String!) {
    editPortfolio(data: $data) {
      status
      response
    }
  }
`;
export const createOwnerDwollaAccount = /* GraphQL */ `
  mutation CreateOwnerDwollaAccount($data: String!) {
    createOwnerDwollaAccount(data: $data) {
      status
      response
    }
  }
`;
export const sendDocumentSlackNotification = /* GraphQL */ `
  mutation SendDocumentSlackNotification(
    $ticketId: Int!
    $documentType: String!
    $portfolioName: String!
    $propertyAddress: String!
    $status: String!
  ) {
    sendDocumentSlackNotification(
      ticketId: $ticketId
      documentType: $documentType
      portfolioName: $portfolioName
      propertyAddress: $propertyAddress
      status: $status
    ) {
      status
      response
    }
  }
`;
export const syncBankAccount = /* GraphQL */ `
  mutation SyncBankAccount($data: String!) {
    syncBankAccount(data: $data) {
      status
      response
    }
  }
`;
export const moveProperty = /* GraphQL */ `
  mutation MoveProperty($data: String!) {
    moveProperty(data: $data) {
      status
      response
    }
  }
`;
export const addUpdateProperty = /* GraphQL */ `
  mutation AddUpdateProperty($data: String!) {
    addUpdateProperty(data: $data) {
      status
      response
    }
  }
`;
export const addUpdateDocument = /* GraphQL */ `
  mutation AddUpdateDocument($data: String!) {
    addUpdateDocument(data: $data) {
      status
      response
    }
  }
`;
export const addUpdateBank = /* GraphQL */ `
  mutation AddUpdateBank($data: String!) {
    addUpdateBank(data: $data) {
      status
      response
    }
  }
`;
export const addUpdateOwner = /* GraphQL */ `
  mutation AddUpdateOwner($data: String!) {
    addUpdateOwner(data: $data) {
      status
      response
    }
  }
`;
export const crudPropertyUnitLease = /* GraphQL */ `
  mutation CrudPropertyUnitLease($data: String!) {
    crudPropertyUnitLease(data: $data) {
      status
      response
    }
  }
`;
export const addOwnerTransaction = /* GraphQL */ `
  mutation AddOwnerTransaction($data: String!) {
    addOwnerTransaction(data: $data) {
      status
      response
    }
  }
`;
export const loginFailures = /* GraphQL */ `
  mutation LoginFailures(
    $email: String
    $role: String
    $portal: String
    $timestamp: String
  ) {
    loginFailures(
      email: $email
      role: $role
      portal: $portal
      timestamp: $timestamp
    ) {
      status
      response
    }
  }
`;
export const updateTenantPayment = /* GraphQL */ `
  mutation UpdateTenantPayment($data: String!) {
    updateTenantPayment(data: $data) {
      status
      response
    }
  }
`;
export const addUpdateCollaborator = /* GraphQL */ `
  mutation AddUpdateCollaborator($data: String!) {
    addUpdateCollaborator(data: $data) {
      status
      response
    }
  }
`;
export const crudVendor = /* GraphQL */ `
  mutation CrudVendor($data: String!) {
    crudVendor(data: $data) {
      status
      response
    }
  }
`;
export const crudPayabli = /* GraphQL */ `
  mutation CrudPayabli($data: String!) {
    crudPayabli(data: $data) {
      status
      response
    }
  }
`;
export const crudCommunications = /* GraphQL */ `
  mutation CrudCommunications(
    $role: String
    $id: Int
    $code: String
    $data: String
    $attachments: String
    $sendToEmail: String
  ) {
    crudCommunications(
      role: $role
      id: $id
      code: $code
      data: $data
      attachments: $attachments
      sendToEmail: $sendToEmail
    ) {
      status
      response
    }
  }
`;
